<header class="top">
    <div class="progress">
        <span class="progress-title">{{ "get-started.title" | translate }}</span>
        <span class="progress-count" data-testid="onboarding-page-progress">{{ "get-started.progress" | translate: progress() }}</span>
    </div>
    <div class="heading">
        @if (isLife()) {
            <h1>{{ "get-started.welcome_title" | translate }}</h1>
            <p>{{ "get-started.welcome_description" | translate }}</p>
        } @else {
            <h1>{{ "overview.welcome_almost_there" | translate }}</h1>
            <p>{{ "overview.welcome_users_can_start" | translate }}</p>
            <p>{{ "overview.started_collecting_money" | translate }}</p>
        }
    </div>
</header>

<ol class="steps">
    @for (step of steps(); track step.key) {
        <li class="step" [class.inactive]="step.status === 'inactive'" [attr.data-testid]="step.rowTestId">
            <div class="marker" [class.done]="step.status === 'done'" [class.inactive]="step.status === 'inactive'">
                @if (step.status === "done") {
                    <span class="check" role="img" [attr.aria-label]="'overview.check_mark' | translate"></span>
                } @else {
                    {{ step.number }}
                }
            </div>
            <div class="content">
                <h3>{{ step.titleKey | translate }}</h3>
                @if (step.detail; as detail) {
                    @switch (detail.kind) {
                        @case ("key") {
                            <p [class.warning]="step.descriptionWarning">{{ detail.key | translate }}</p>
                        }
                        @case ("plan") {
                            <p>{{ detail.key | translate: { plan: detail.planNameKey | translate, interval: detail.interval } }}</p>
                        }
                        @case ("text") {
                            <p>{{ detail.text }}</p>
                        }
                    }
                }
            </div>
            @switch (step.button) {
                @case ("edit") {
                    <app-aw-button color="text-underlined" [minWidthPercentage]="0" (clickEmitter)="openStep(step.key)" [dataTestId]="step.buttonTestId">
                        <span button-content>{{ "overview.edit" | translate }}</span>
                    </app-aw-button>
                }
                @case ("action") {
                    <app-aw-button class="action" color="secondary" [minWidthPercentage]="0" [disabled]="step.actionDisabled" [loading]="step.actionLoading" (clickEmitter)="openStep(step.key)" [dataTestId]="step.buttonTestId">
                        <span button-content>{{ step.actionKey | translate }}</span>
                    </app-aw-button>
                }
            }
        </li>
    }
</ol>

@if (isLife()) {
    <div class="banner" role="note">
        <img src="assets/icons/onboarding/info-circle.svg" width="20" height="20" alt="" aria-hidden="true" />
        <p>{{ "get-started.payouts_banner" | translate }}</p>
    </div>
}
